import type { LocationQueryRaw } from 'vue-router';
import { useRouter } from 'vue-router';

import type { ApiTabValueType } from './types';

export default function useApiRoutes() {
  const router = useRouter();

  function openTab(tab: ApiTabValueType) {
    return router.push({ name: 'api', params: { tab } });
  }

  function openCreate(tab: ApiTabValueType) {
    return router.push({ name: 'api_create', params: { tab } });
  }

  function openDetail(
    tab: ApiTabValueType,
    id: string,
    {
      replace = false,
      query,
    }: { replace?: boolean; query?: LocationQueryRaw } = {},
  ) {
    const location = {
      name: 'api_detail',
      params: { tab, id },
      ...(query && { query }),
    };
    return replace ? router.replace(location) : router.push(location);
  }

  function isTabPath(path: string, tab: ApiTabValueType) {
    const { name, params } = router.resolve(path);
    return name === 'api' && params.tab === tab;
  }

  function closeOverlay(tab: ApiTabValueType) {
    const back = window.history.state?.back;
    if (back && isTabPath(back, tab)) return router.back();
    return router.replace({ name: 'api', params: { tab } });
  }

  return { openTab, openCreate, openDetail, closeOverlay };
}
